import { useParams } from "react-router-dom"
import { DepartmentView } from "@/features/departments/components/DepartmentView"

export default function DepartmentPage() {
  const { departmentId } = useParams()

  return <DepartmentView departmentId={departmentId!} />
}